export const selectFilesToDownload = (state) => ({
    pages: state.filesToDownload.pages,
    pagination: state.filesToDownload.pagination,
});
